import { Component } from '@angular/core';

@Component({
  selector: 'app-end-user-license-agreement',
  templateUrl: './end-user-license-agreement.component.html',
  standalone :false
})
export class EndUserLicenseAgreementComponent {

}
